import { RevenueShareEligibilityStatus } from 'flow-schema';

export const FEATURED_FLOW_TEMPLATE_CARD_HEIGHT_IN_PIXELS = 360;
export const FLOW_TEMPLATE_CARD_HEIGHT_IN_PIXELS = 272;
export const VENDOR_ICON_SIZE_IN_PIXELS = 24;

export const MAX_VENDOR_ICONS = 5;

// 640x236 aspect ratio with max file size of 5MB for template thumbnails
export const MAX_TEMPLATE_THUMBNAIL_FILE_SIZE_IN_MEBIBYTES = 5;
export const MIN_TEMPLATE_THUMBNAIL_WIDTH_IN_PIXELS = 640;
export const MIN_TEMPLATE_THUMBNAIL_HEIGHT_IN_PIXELS = 236;
export const TEMPLATE_THUMBNAIL_ASPECT_RATIO =
  MIN_TEMPLATE_THUMBNAIL_WIDTH_IN_PIXELS / MIN_TEMPLATE_THUMBNAIL_HEIGHT_IN_PIXELS;

// 16x9 aspect ratio with max file size of 2MB for case study images
export const MAX_CASE_STUDY_IMAGE_FILE_SIZE_IN_MEBIBYTES = 2;
export const MIN_CASE_STUDY_IMAGE_WIDTH_IN_PIXELS = 320;
export const MIN_CASE_STUDY_IMAGE_HEIGHT_IN_PIXELS = 180;
export const CASE_STUDY_IMAGE_ASPECT_RATIO =
  MIN_CASE_STUDY_IMAGE_WIDTH_IN_PIXELS / MIN_CASE_STUDY_IMAGE_HEIGHT_IN_PIXELS;

export const MAX_TEMPLATE_NAME_LENGTH = 75;
export const MAX_TEMPLATE_NAME_DISPLAY_LENGTH = 50;
export const MAX_FLOW_DESCRIPTION_LENGTH = 98;

export const MAX_TEMPLATE_CASE_STUDY_TITLE_LENGTH = 115;

export const OTHER_TAG_NAME = 'Other';

export const REVENUE_SHARE_ELIGIBILITY_STATUS_TO_CONTENT: Record<
  RevenueShareEligibilityStatus,
  string
> = {
  [RevenueShareEligibilityStatus.Eligible]: 'Eligible',
  [RevenueShareEligibilityStatus.NotEligible]: 'Not Eligible',
};
